
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Brain, Target, Palette, Ruler, Award, TrendingUp } from "lucide-react";
import { EnhancedColorResult } from "@/hooks/color-check/types";

interface ResultHeaderProps {
  colorResult: EnhancedColorResult;
  hasExactMatches: boolean;
  hasExactSizeMatches: boolean;
  hasExactColorMatches: boolean;
  hasInventoryMatches: boolean;
}

const ResultHeader = ({ 
  colorResult, 
  hasExactMatches, 
  hasExactSizeMatches, 
  hasExactColorMatches, 
  hasInventoryMatches 
}: ResultHeaderProps) => {
  const confidencePercentage = Math.round(colorResult.basePrediction.confidence * 100);

  const getMatchQualityBadge = () => {
    if (hasExactColorMatches && hasExactSizeMatches) {
      return (
        <Badge className="bg-green-100 text-green-800">
          <Target className="mr-1 h-3 w-3" />
          Perfecte Match
        </Badge>
      );
    }
    if (hasExactColorMatches) {
      return (
        <Badge className="bg-blue-100 text-blue-800">
          <Palette className="mr-1 h-3 w-3" />
          Juiste Kleur Match
        </Badge>
      );
    }
    if (hasExactSizeMatches) {
      return (
        <Badge className="bg-orange-100 text-orange-800">
          <Ruler className="mr-1 h-3 w-3" />
          Maat Match - Verkeerde Kleur
        </Badge>
      );
    }
    if (hasInventoryMatches) {
      return (
        <Badge variant="outline" className="bg-yellow-50 text-yellow-700">
          <Award className="mr-1 h-3 w-3" />
          Alternatief Match
        </Badge>
      );
    }
    return null;
  };

  const getDescription = () => {
    if (hasExactColorMatches && hasExactSizeMatches) {
      return 'Perfecte kleur en maat match gevonden!';
    } else if (hasExactColorMatches) {
      return 'Juiste kleur gevonden - andere maat beschikbaar';
    } else if (hasExactSizeMatches) {
      return 'Juiste maat gevonden - verkeerde kleur';
    } else {
      return 'Slimme analyse van:';
    }
  };

  return (
    <>
      <div className="flex items-center">
        <Brain className="mr-2 h-5 w-5 text-blue-500" />
        Exacte Kleur & Product Matching
      </div>
      <div className="flex items-center gap-2">
        {getMatchQualityBadge()}
        <Badge variant="outline" className="bg-blue-50">
          <TrendingUp className="mr-1 h-3 w-3" />
          {confidencePercentage}% zekerheid
        </Badge>
      </div>
    </>
  );
};

export { ResultHeader, type ResultHeaderProps };
